// These values match the REPORT_TYPE constant on each of the four report models, and the server
// hands the value to the report builder pages as the reportType prop.
export const SOLUTION_REPORT_TYPE = "solution"
export const SUBMISSION_REPORT_TYPE = "submission"
export const SURVEY_REPORT_TYPE = "survey"
export const TASK_REPORT_TYPE = "task"

export const REPORT_TYPES = [
  SUBMISSION_REPORT_TYPE,
  SOLUTION_REPORT_TYPE,
  SURVEY_REPORT_TYPE,
  TASK_REPORT_TYPE,
]

export const MY_REPORTS_OPTION = "mine"
export const SHARED_WITH_ME_OPTION = "sharedWithMe"

export const SCHEDULED_ACTIVE_SFTP_OPTION = "scheduledActive"
export const SCHEDULED_INACTIVE_SFTP_OPTION = "scheduledInactive"
export const NOT_SCHEDULED_SFTP_OPTION = "notScheduled"
